import script from "./GoodyList.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodyList.vue?vue&type=script&setup=true&lang=js"

import "./GoodyList.vue?vue&type=style&index=0&id=d3fff7f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3fff7f8"]])

export default __exports__